module.exports = __webpack_public_path__ + "img/Fourcircles.47e8c8fe.svg";